import { hasYesOrNo } from 'models/validate';
import legalAssociationsTerroristOrganizationItemValidator from 'forms/sections/legal/associations/terroristOrganization/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsTerroristOrganizationModel } from './types';

const legalAssociationsTerroristOrganizationValidator: ValidateJSModel<LegalAssociationsTerroristOrganizationModel> = {
  HasTerrorist: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasTerrorist?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsTerroristOrganizationItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsTerroristOrganizationValidator;
